import { useState, useEffect } from 'react';
import { Flex } from '../../component-library';
import { PatientFacialDetection } from '../../components';
import { useTestContext } from '../../context/testContext';
import { useReceiveMessage } from '../../context/messageContext';

const KaysOptotypes = () => {
  const { testData } = useTestContext();
  const [currentOptotypeIndex, setCurrentOptotypeIndex] = useState(0);
  const [currentLogmarSize, setCurrentLogmarSize] = useState(0);
  const messageFromOptician = useReceiveMessage();
  const [logmarData, setLogmarData] = useState({});
  const [optotypes, setOptotypes] = useState([]);
  const [imageIsCrowded, setImageIsCrowded] = useState(false);

  useEffect(() => {
    const importOptotypes = (src) => src.keys().map(src);
    const optotypes = importOptotypes(require.context('../../assets/kays-optotypes', false, /\.svg$/));
    setOptotypes(optotypes);
  }, []);

  useEffect(() => {
    setCurrentLogmarSize(logmarData.size);
    setCurrentOptotypeIndex(logmarData.currentOptotypeIndex);
  }, [logmarData.currentOptotypeIndex, logmarData.size]);

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'kaysOptotypes':
        setImageIsCrowded(messageFromOptician.content.crowding === 'crowded');
        setLogmarData({
          size: messageFromOptician.content.contentSize,
          distance: messageFromOptician.content.distanceFromScreen,
          currentOptotypeIndex: messageFromOptician.content.currentOptotypeIndex,
        });
        break;
      case 'resizeOptotype':
        setLogmarData({
          size: messageFromOptician.content.contentSize,
          distance: messageFromOptician.content.distanceFromScreen,
          currentOptotypeIndex: messageFromOptician.content.currentOptotypeIndex,
        });
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  return (
    <Flex>
      <PatientFacialDetection testMode={testData.testMode} />
      <Flex bg='white' width='100vw' alignItems='center' height='100vh' justifyContent='center' style={{ zIndex: '9' }}>
        <img
          src={optotypes[currentOptotypeIndex]?.default}
          alt='kays-optotype'
          style={{
            width: currentLogmarSize,
            height: currentLogmarSize,
            overflow: 'hidden',
            ...(imageIsCrowded && { borderStyle: 'solid', borderWidth: currentLogmarSize / 8, padding: logmarData.size / 3 }),
          }}
        />
      </Flex>
    </Flex>
  );
};

export default KaysOptotypes;
